import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-form"
export default class extends Controller {
  static targets = ["kind", "extensionWrapper", "extensionInput"]
  static classes = ["hidden"]

  isWork() {
    return this.kindTarget.value === "work"
  }

  handleKindChange() {
    this.extensionWrapperTarget.classList.toggle(this.hiddenClass, !this.isWork())

    if (!this.isWork()) {
      this.extensionInputTarget.value = ''
    }
  }
}
